import type { AxiosError } from 'axios';
import type { ethers } from 'ethers';
import type { SWRConfiguration } from 'swr';
import useSWR from 'swr';

import { useCurrentWallet } from './useCurrentWallet';
import useProvider from './useProivder';

type FetchParams = {
  address: string;
  provider: ethers.BrowserProvider;
};

type UseBalanceSWRProps = {
  address: string;
};

export function useBalanceSWR({ address }: UseBalanceSWRProps, config?: SWRConfiguration) {
  const { provider } = useProvider();
  const { currentWallet } = useCurrentWallet();

  const fetcher = async (params: FetchParams) => provider?.getBalance(params.address);

  const { data, isValidating, error, mutate } = useSWR<bigint | undefined, AxiosError>({ id: 'ethBalance', address }, fetcher, {
    dedupingInterval: 9000,
    refreshInterval: 10000,
    errorRetryCount: 0,
    isPaused: () => !address || !provider || !currentWallet.name,
    ...config,
  });

  return { data, isValidating, error, mutate };
}
